import React from 'react';
import { View, Image } from 'react-native';

import { styles } from './LeadScoreModal.styles';
import CentralModal from 'src/components/CenteredModal/CenteredModal';
import cardTruck from 'src/assets/cardTruck-4x.png';
import Typography from 'src/components/Text/Text';
import Button from 'src/components/Button/Button';
interface SecondUserScreenProps {
  leadModalVisible: boolean;
  setLeadModalVisible: (visible: boolean) => void;
}

const SecondUserScreen: React.FC<SecondUserScreenProps> = ({
  leadModalVisible,
  setLeadModalVisible,
}) => {
  // const [isVisible, setIsVisible] = useState(false);

  const handleContinue = () => {
    setLeadModalVisible(false);
  };

  return (
    <CentralModal visible={leadModalVisible}>
      <View style={styles.container}>
        <View style={styles.logoContainer}>
          <Image source={cardTruck} style={styles.logoImage} />
        </View>
        <Typography style={styles.topText} variant="h4">
          Thank you for considering working with us
        </Typography>
        <Typography variant="body1" style={styles.bottomText}>
          One of our Senior Producers will call you shortly to help you find the best coverages with
          the best insurance providers
        </Typography>
        <Typography variant="body1" style={styles.bottomText}>
          {`If you would like to generate automated quotes for yourself right away, please click
          'continue'.`}
        </Typography>
        <Button type="primary" title="Continue" onPress={handleContinue} />
      </View>
    </CentralModal>
  );
};

export default SecondUserScreen;
